import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { ApiService }               from '../api/api.service';
import { ProlinkSettingsComponent } from './prolink.settings.component';
import { ProlinkSettingsModel }     from './typings/prolink.settings';
import { SessionService }           from '../sessions/session.service';

export const ProlinkStates : Array<NgHybridStateDeclaration> = [
  {
    component: ProlinkSettingsComponent,
    name     : 'app.prolink-settings',
    resolve  : [
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : ng.IPromise<any> => sessionService.refresh(),
        token    : 'session'
      },
      {
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) : ng.IPromise<ProlinkSettingsModel> => apiService.get('/company'),
        token    : 'settings'
      }
    ],
    url: '/prolink_settings'
  }
];
